import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_license_plate_navigation_list_extendedService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { material_id?: number, project_id?: number, location_id?: number, full_text_search?: string, license_plate?: number, $top?: number, $skip?: number }): Promise<{ result?: { licensePlateLookupCode?: string, id?: number, lotLookupCode?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_license_plate_navigation_list_extended/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { material_id?: number, project_id?: number, location_id?: number, full_text_search?: string, license_plate?: number, $keys: number[] }): Promise<{ result?: { licensePlateLookupCode?: string, id?: number, lotLookupCode?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_license_plate_navigation_list_extended/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      material_id?: number, project_id?: number, location_id?: number, full_text_search?: string, license_plate?: number    }) {
      return false;
    }
}
